import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 43 75",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.032 1.459a1 1 0 0 1 1-1h28.405a1 1 0 0 1 1 1v4.715h.114v2h-3.048v3.576a10.368 10.368 0 0 1 5.624 2.916 10.47 10.47 0 0 1 3.04 7.381v47.21c0 1.515-.599 2.97-1.666 4.043a5.68 5.68 0 0 1-4.028 1.678H5.967A5.68 5.68 0 0 1 1.939 73.3a5.735 5.735 0 0 1-1.666-4.043v-47.21a10.47 10.47 0 0 1 3.04-7.381 10.368 10.368 0 0 1 5.662-2.922v-3.57H5.919v-2h.113V1.459Zm2 4.715h26.405V2.459H8.032v3.715Zm2.943 2v3.431h20.528V8.174H10.975Zm-6.243 7.902a8.359 8.359 0 0 1 5.928-2.47h21.12c2.222 0 4.355.887 5.928 2.47a8.47 8.47 0 0 1 2.459 5.971v2.957H2.273v-2.957a8.47 8.47 0 0 1 2.459-5.971ZM2.273 27.004h37.894v34.824H2.273V27.004Zm0 36.824v5.429c0 .989.391 1.936 1.084 2.633a3.68 3.68 0 0 0 2.61 1.088h30.506a3.68 3.68 0 0 0 2.61-1.088 3.736 3.736 0 0 0 1.084-2.633v-5.43H2.273Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }